<template lang="pug">
div.pt-0.pb-8
  div.d-flex.align-center
    div
      div.text-lg.font-semibold.neutral700--text {{ $t('user_roles') }}
      div.text-sm.neutral700--text {{ $t('user_roles_desc') }}
    v-spacer
    v-btn.button-sm(color="primary" outlined @click="addNewUser")
      v-icon(left) mdi-plus
      | {{ $t('new_user') }}
  div.d-flex.justify-center.mt-16(v-if="isFetching")
    v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
  template(v-else)
    v-card.round-xl.mt-6(outlined)
      template(v-for="(member, pidx) in members")
        div.pa-4.d-flex.align-center(:key="'user-' + pidx")
          intel-avatar(:code="member.user.avatar_code" :id="member.user.id" size="60")
          div.text-md.font-medium.neutral700--text.ml-6 {{ member.user.first_name + ' ' + member.user.last_name }}
          v-chip.text-sm.ml-3(label small :class="member.role === 'Admin' ? 'danger500--text' : 'warning700--text'" :color="member.role === 'Admin' ? 'danger100' : 'warning200'") {{ member.role === 'Admin' ? $t('admin') : $t('clinic_assistant') }}
          v-spacer
          div
            y-switch.mb-n2(v-model="member.enabled" @change="changeStatus(member)")
          v-menu(offset-y left rounded="lg")
            template(#activator="{ on }")
              v-btn.ml-4(icon small v-on="on")
                v-icon mdi-dots-horizontal
            v-list(dense)
              v-list-item(@click="editUser(member)")
                v-list-item-title.text-sm.basic800--text {{ $t('edit_user') }}
              v-divider
              v-list-item(@click="deleteUser(member)")
                v-list-item-title.text-sm.danger500--text {{ $t('delete_user') }}
          
        v-divider(v-if="pidx !== (members.length - 1)")

  .dialogs
    edit-user-dialog(v-if="showUserDialog" :open.sync="showUserDialog" :user="selectedUser" @reset="reset" @closed="closed")
    delete-user-dialog(v-if="showDeleteDialog" :open.sync="showDeleteDialog" :user="selectedUser" @reset="reset" @closed="closed")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import IntelAvatar from '@/components/IntelAvatar.vue'
import EditUserDialog from '@/components/clinic/dialogs/EditUserDialog.vue'
import DeleteUserDialog from '@/components/clinic/dialogs/DeleteUserDialog.vue'

export default {
  name: 'UserRoles',
  components: { IntelAvatar, EditUserDialog, DeleteUserDialog },
  data () {
    return {
      isFetching: false,
      showUserDialog: false,
      showDeleteDialog: false,
      selectedUser: null,
      members: []
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
  },
  mounted () {
    this.fetchMembers()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchMembers () {
      this.isFetching = true
      const params = {
        company: this.company.id,
        exclude_roles: 3,
        page_size: -1
      }
      this.$axios.get(`/members/`, { params } )
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.members = resp.data.results
            this.members = this.members.map(m =>  { return { ...m, enabled: m.status === 'active' }})
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    addNewUser () {
      this.showUserDialog = true
    },
    editUser (member) {
      this.selectedUser = member
      this.showUserDialog = true
    },
    deleteUser (member) {
      this.selectedUser = member
      this.showDeleteDialog = true
    },
    successDeleteUser () {
      this.fetchMembers()
      this.selectedUser = null
    },
    changeStatus (member) {
      this.$axios.patch(`/members/${member.id}`, { status: member.enabled ? 'active' : 'inactive' })
        .then(resp => {
          this.$set(member, 'status', resp.data.status)
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    reset () {
      this.fetchMembers()
      this.selectedUser = null
    },
    closed () {
      this.selectedUser = null
    }
  }
}
</script>

<style scoped>
.empty-box {
  position: relative;
  border-radius: 10px;
  border: var(--v-basic500) dashed 2px;
}
</style>